import React, { FC, useEffect, useState } from 'react';
import { EditApplicationsContainer } from './viewApplicationEditScreen.styles';
import { TextInputField, TextAreaField } from '@sainsburys-tech/luna-react';
import { IApplicationDetails } from 'src/interfaces/application.interface';
import { Button } from '@sainsburys-tech/luna-react';
import { ScreenFeedback } from 'src/screens/components/screenFeedback';
import { ApolloError } from '@apollo/client';
import { NotificationType } from 'src/enums/notificationTypes.enum';
import { PanelActions } from 'src/components/PanelActions/panelActions.styles';

interface IHeading {
  heading: string;
  subHeading: string;
}

interface IDetailsToChange {
  acronym?: string;
  name?: string;
  shortDescription?: string;
  longDescription?: string;
}
interface IDetails {
  acronym: string;
  name: string;
  shortDescription: string;
  longDescription: string;
}

interface IEditApplicationDetailsScreen {
  handleClose: () => void;
  handleConfirmation: (status: IDetailsToChange) => void;
  loading: boolean;
  error: ApolloError | undefined;
  target: { id: string; displayName: string };
  detailsHeading: IHeading;
  details: IDetails;
}

export const EditApplicationDetailsScreen: FC<
  IEditApplicationDetailsScreen
> = ({
  handleConfirmation,
  handleClose,
  error,
  detailsHeading,
  loading,
  target,
  details,
}) => {
  const [detailsToChange, setDetailsToChange] = useState<IDetailsToChange>({});
  const [feedBackMessage, setFeedBackMessage] =
    useState<NotificationType | null>(null);
  useEffect(() => {
    if (error) {
      setFeedBackMessage(NotificationType.FAILURE);
    }
  }, [error]);

  const handleReset = () => {
    setDetailsToChange({});
    setFeedBackMessage(null);
  };

  return (
    <>
      <EditApplicationsContainer>
        {feedBackMessage ? (
          <>
            <ScreenFeedback
              isLoading={false}
              notificationType={feedBackMessage}
              feedBackMessage={
                feedBackMessage === NotificationType.SUCCESS
                  ? `The details for ${target.displayName} ${
                      Object.keys(detailsToChange).length === 1 ? 'has' : 'have'
                    } been updated.`
                  : `Failed to update the details for ${target.displayName}.`
              }
              saveButtonText={'Save and close'}
              onCloseHandler={handleClose}
              resetButtonText={'Further changes'}
              resetHandler={handleReset}
              notificationMessage={
                feedBackMessage === NotificationType.SUCCESS
                  ? `${target.displayName} successfully updated`
                  : `Failed to update ${target.displayName}`
              }
            />
          </>
        ) : (
          <>
            <div className='tab-heading'>
              <h3>{detailsHeading.heading}</h3>
            </div>
            <div className='panel-body'>
              <TextInputField
                name='text-input-field-2'
                label='Acronym'
                defaultValue={details.acronym}
                onChange={(e: any) =>
                  setDetailsToChange({
                    ...detailsToChange,
                    acronym: e.target.value,
                  })
                }
              />
              <TextInputField
                name='text-input-field-2'
                label='Name'
                defaultValue={details.name}
                onChange={(e: any) =>
                  setDetailsToChange({
                    ...detailsToChange,
                    name: e.target.value,
                  })
                }
              />
              <TextInputField
                name='text-input-field-2'
                label='Short description'
                defaultValue={details.shortDescription}
                onChange={(e: any) =>
                  setDetailsToChange({
                    ...detailsToChange,
                    shortDescription: e.target.value,
                  })
                }
              />
              <TextAreaField
                name='text-input-field-2'
                label='Long description'
                defaultValue={details.longDescription}
                onChange={(e: any) =>
                  setDetailsToChange({
                    ...detailsToChange,
                    longDescription: e.target.value,
                  })
                }
              />
            </div>
          </>
        )}
      </EditApplicationsContainer>
      {!feedBackMessage && (
        <PanelActions>
          <Button
            onClick={() => {
              if (Object.keys(detailsToChange).length !== 0) {
                handleConfirmation(detailsToChange);
                setFeedBackMessage(NotificationType.SUCCESS);
              }
            }}
            variant='filled'
            disabled={loading || Object.keys(detailsToChange).length === 0}
          >
            Update details
          </Button>
          <Button onClick={handleClose} variant='outlined'>
            Cancel
          </Button>
        </PanelActions>
      )}
    </>
  );
};
